import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { actions as TrackingActions } from 'app/modules/tracking'
import LoadingDots from 'components/shared/LoadingDots'
import OauthConnector from './OauthConnector'
import ConnectLink from './ConnectLink'
import Connected from './Connected'
import withNotifications from 'components/shared/notifications'

import { createAccessToken, fetchIntegrationStates, updateIntegrationState } from 'app/modules/integrations/actions'
import { connectionsRoot, didCreateAccessToken, failedCreateAccessToken } from 'app/modules/integrations/selectors'

class IntegrationConnector extends Component {

  static defaultProps = {
    postSuccessCB: () => { },
    title: 'CONNECT ACCOUNT'
  }

  state = {
    updating: false
  }

  componentWillReceiveProps({ integrationStates, accessTokenCreated, failedCreateAccessToken, integrationId, postSuccessCB }) {
    const currentIntegrationStates = this.props.integrationStates

    if ((currentIntegrationStates[integrationId] !== integrationStates[integrationId]) || accessTokenCreated) {
      this.setState({ updating: false })
      if (integrationStates[integrationId]) {
        postSuccessCB()
      }
    }

    if (failedCreateAccessToken) {
      this.props.notifications.error("We could not connect. Please check your input and try again.")
      this.setState({ updating: false })
    }
  }

  handleConnect = () => {
    const { integrationId, connectionPayload, actions } = this.props
    actions.createAccessToken({ integrationName: integrationId, body: connectionPayload })
    actions.track('Integration Connected', { integration: integrationId, connected: true })
    this.setState({ updating: true })
  }

  handleDisconnect = () => {
    const { integrationId, actions } = this.props
    actions.updateIntegrationState({ integration: integrationId, connected: false })
    actions.track('Integration Disconnected', { integration: integrationId, connected: false })
    this.setState({ updating: true })
  }

  renderOauthConnector = () => {
    const { props } = this
    return <OauthConnector
      trackingPayload={props.trackingPayload}
      handleConnect={this.handleConnect}
      label={props.title}
      {...props}
    />
  }

  renderNotConnected = () => {
    const { isOauth } = this.props
    if (isOauth) {
      return this.renderOauthConnector()
    }
    return <ConnectLink handleConnect={this.handleConnect} />
  }

  renderConnected = () => {
    const { integrationId } = this.props
    return <Connected integrationId={integrationId} handleDisconnect={this.handleDisconnect} />
  }

  renderConnectors = () => {
    const { isConnected } = this.props
    if (isConnected) {
      return this.renderConnected()
    } else {
      return this.renderNotConnected()
    }
  }

  render() {

    const { updating } = this.state
    return (
      <div className={this.props.className}>
        {updating ?
          <div style={{ paddingTop: '1rem', maxWidth: '50px' }}><LoadingDots /></div> :
          this.renderConnectors()
        }
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const integrationName = props.integrationId || ''

  return {
    integrationStates: connectionsRoot(state),
    accessTokenCreated: didCreateAccessToken(state, integrationName),
    accessTokenCreationFailed: failedCreateAccessToken(state, integrationName)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      track: TrackingActions.track,
      createAccessToken,
      fetchIntegrationStates,
      updateIntegrationState
    }, dispatch)
  }
}

const IntegrationConnectorConnect = withNotifications(connect(
  mapStateToProps,
  mapDispatchToProps
)(IntegrationConnector))

export default IntegrationConnectorConnect



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/IntegrationConnector.js